import { PropsWithChildren } from 'react'
import classNames from 'classnames'
import styles from 'features/registration/steps/confirmation/Confirmation.module.scss'

const ConfirmationWrapper = ({ children, limitedWidth }: PropsWithChildren<{ limitedWidth?: boolean }>) => {
  return (
    <main
      className={classNames(styles.confirmation, {
        [styles['limited-width']]: limitedWidth
      })}
    >
      {children}
    </main>
  )
}

export default ConfirmationWrapper
